import { LOCALES, type LocaleCode } from '../i18n/strings.js';

/**
 * Which language a passenger sees first.
 *
 * The staff consoles follow the browser, because their users chose their own
 * device language. A passenger app cannot reason that way: an operator in
 * Kinshasa serves people whose phones are very often set to English simply
 * because that is what shipped on them, and answering in English is the wrong
 * guess about what they read.
 *
 * So the ORDER IS: the passenger's own choice, then the operator's default, then
 * the browser, then English. The operator outranks the phone; the passenger
 * outranks everyone.
 */
export function isLocale(value: string | null | undefined): value is LocaleCode {
  return !!value && LOCALES.some((locale) => locale.code === value);
}

export function chooseLocale(input: {
  stored: string | null;
  tenant: string | null;
  browser: readonly string[];
}): LocaleCode {
  if (isLocale(input.stored)) return input.stored;
  if (isLocale(input.tenant)) return input.tenant;
  for (const tag of input.browser) {
    // "sw-TZ" and "fr-CD" are the common shapes; match on the base language.
    const base = tag.split('-')[0];
    if (isLocale(base)) return base;
  }
  return 'en';
}
